import firebase from 'firebase';

var firebaseConfig = {
apiKey: "AIzaSyDzoSnnNST8I4vfg5PHqIhwC6rdSI0bmY0",
authDomain: "lpas-7a813.firebaseapp.com",
projectId: "lpas-7a813",
storageBucket: "lpas-7a813.appspot.com",
messagingSenderId: "41413361853",
appId: "1:41413361853:web:c300605dfccf68e7ddf7d4"
};


const fire = firebase.initializeApp(firebaseConfig);

export default fire;